'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MarkdownContainer = require('./components/MarkdownContainer');

var _MarkdownContainer2 = _interopRequireDefault(_MarkdownContainer);

var _Story = require('./components/Story');

var _Story2 = _interopRequireDefault(_Story);

var _StoryPreview = require('./components/StoryPreview');

var _StoryPreview2 = _interopRequireDefault(_StoryPreview);

var _FooterDocs = require('./components/FooterDocs');

var _FooterDocs2 = _interopRequireDefault(_FooterDocs);

var _common = require('../common');

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function renderStory(_ref) {
  var storyFn = _ref.storyFn,
      kind = _ref.kind,
      story = _ref.story,
      docs = _ref.docs,
      config = _ref.config;

  return {
    data: function data() {
      return {
        story: storyFn({ kind: kind, story: story })
      };
    },
    render: function render(h) {
      return h(_Story2.default, {
        props: {
          docs: docs
        }
      }, [h(config.PreviewComponent ? config.PreviewComponent : _StoryPreview2.default, [h(this.story)]), h(config.FooterComponent ? config.FooterComponent : _FooterDocs2.default, {
        slot: 'footer'
      }, [h(_MarkdownContainer2.default, {
        props: {
          docs: [config.docsAtFooter]
        }
      })])]);
    }
  };
}

function withDocsCallAsHoc(_ref2) {
  var docs = _ref2.docs,
      config = _ref2.config,
      storyFn = _ref2.storyFn;

  return function (_ref3) {
    var kind = _ref3.kind,
        story = _ref3.story;
    return renderStory({
      docs: docs,
      config: config,
      storyFn: storyFn,
      kind: kind,
      story: story
    });
  };
}

function withDocsCallAsDecorator(_ref4) {
  var docs = _ref4.docs,
      config = _ref4.config;

  return function (storyFn, _ref5) {
    var kind = _ref5.kind,
        story = _ref5.story;
    return renderStory({
      docs: docs,
      config: config,
      storyFn: storyFn,
      kind: kind,
      story: story
    });
  };
}

function doc(_ref6) {
  var docs = _ref6.docs,
      config = _ref6.config;

  return function (_ref7) {
    var kind = _ref7.kind,
        story = _ref7.story;
    return renderStory({
      docs: {},
      config: Object.assign({}, config, {
        PreviewComponent: {
          template: '<div><slot></slot></div>'
        }
      }),
      storyFn: function storyFn(k, v) {
        return {
          data: function data() {
            return {
              docs: docs
            };
          },

          components: {
            MarkdownContainer: _MarkdownContainer2.default
          },
          template: '<markdown-container :docs="docs" />'
        };
      },
      kind: kind,
      story: story
    });
  };
}

exports.default = {
  doc: doc,
  withReadme: _common2.default.withReadme,
  withDocs: {
    callAsDecorator: withDocsCallAsDecorator,
    callAsHoc: withDocsCallAsHoc
  }
};